/**
 * Pure helpers for the Settings / Teams analytics events
 * (RFC-1577 §6). Each turns product state into the closed values the schema
 * declares (schemas/analytics/fields/teams_settings.json) — never free text.
 */

import type { SettingsEntryPoint } from '../components/settings/settings-modal/settingsModalContextRaw'
import type { InviteExpiryBucket, SettingsViewEntryPoint } from './generated/analyticsEvents'

/**
 * How a Settings section came to be on screen.
 *
 * `navigated` wins: a user who opened Settings from the menu and then clicked
 * the section in the nav column reached it by the nav, not the menu. The
 * profile flyout opens Teams straight into the create form, which is the only
 * thing that tells it apart from a plain user-menu open.
 */
export function settingsViewEntryPoint(args: {
  dialogEntryPoint: SettingsEntryPoint
  navigated: boolean
  fromProfileFlyout: boolean
}): SettingsViewEntryPoint {
  if (args.navigated) return 'settings_nav'
  if (args.dialogEntryPoint === 'settings_deeplink') return 'settings_deeplink'
  if (args.fromProfileFlyout) return 'profile_flyout'
  return 'user_menu'
}

/** Exact match against the invite panel's expiry choices; anything else is omitted. */
export function inviteExpiryBucket(days: number): InviteExpiryBucket | undefined {
  if (days === 1) return '1d'
  if (days === 7) return '7d'
  if (days === 30) return '30d'
  return undefined
}
